// extracted by mini-css-extract-plugin
module.exports = {"sharingCell":"SharingTable_sharingCell__3wf72","spinner":"SharingTable_spinner__3nwlI"};